module.exports = __webpack_public_path__ + "img/10.a8ee1f35.jpg";